

// artworks-image
window.artworksImage = function(){
    return {
        initialize(){
            $('.slider-for').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: true,
                asNavFor: '.slider-nav'
            });
            $('.slider-nav').slick({
                slidesToShow: 6,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 6,
                            slidesToScroll: 1,
                        },
                    },
                ],
                asNavFor: '.slider-for',
                dots: false,
                arrows: false,
                //centerMode: true,
                focusOnSelect: true,
                // prevArrow: '',
                // nextArrow: `
                // <svg class="slick-next" width="25" height="33" viewBox="0 0 25 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                //     <path d="M0.36084 1L23.3608 16.5L0.360841 32" stroke="#306FB8"/>
                // </svg>

                //   `,
                // variableWidth: true,
            });
            $('.arrow-prev').on('click', function() {
                $('.slider').slick('slickPrev');
            });
            $('.arrow-next').on('click', function() {
                $('.slider').slick('slickNext');
            });
        },
        // slickの仕様上、x-showでのdisplay:none付け外しでは正常に動かないため、visibilityを付け外しする
        imagesModalSwitch() {
            if ($('#images-modal').hasClass('invisible')) {
                $('#images-modal').removeClass('invisible');
            } else {
                $('#images-modal').addClass('invisible');
            }
        }
    }
}

window.artworksWishListAndSns = function(){
    return {
        show_sns:false,
        initialize(){

        },
        onClickWish(){
            var action = this.$store.artworks.is_wish ? 'remove' : 'add';
            this.$fetch({
                url: this.$store.ajax_url.add_wish,
                method: 'post',
                data: {
                    product_id: this.$store.artworks.item_id,
                    action: action,
                }
            })
            .then(({ data }) => {
                this.$store.artworks.is_wish = action == 'remove' ? false : true;
            })
        },
        onClickSnsPopup(){
            this.show_sns = !this.show_sns;
        },
    }
}

window.artworksListWish = function(){
    return {
        is_wish:false,
        item_id:null,
        initialize(){
            var id = this.$el.dataset.id*1;
            this.item_id = id;
            this.is_wish = wishlist.indexOf(id) != -1;
        },
        onClickWish(){
            var action = this.is_wish ? 'remove' : 'add';
            this.$fetch({
                url: this.$store.ajax_url.add_wish,
                method: 'post',
                data: {
                    product_id: this.item_id,
                    action: action,
                }
            })
            .then(() => {
                this.is_wish = action == 'remove' ? false : true;
            })
        },
    }
}